import { createAction, props } from "@ngrx/store";

export const setEndTimer = createAction(
  '[Timer] Set End Timer',
  props<{ endTimer: number }>()
);

export const resetEndTimer = createAction(
  '[Timer] Reset End Timer'
);
